import _ from 'lodash';
import { SearchResultsListItemRecentSearch } from '../components';
import { MagicSearchPluginSync, MagicSearchPluginName, ResultItem } from './types';
import {
  createRecentSearchesPluginStore,
  CreateRecentSearchesPluginStoreParams,
} from './RecentSearchesPluginStore';
import { RECENT_SEARCHES_SECTION_TITLE } from '../constants';

const recentSearchesPlugin = ({
  localStorageKey,
}: CreateRecentSearchesPluginStoreParams): MagicSearchPluginSync => {
  const recentSearchesPluginStore = createRecentSearchesPluginStore({ localStorageKey });
  return {
    name: MagicSearchPluginName.RecentSearchesPlugin,
    onSearch: ({ searchText, searchScopes }) => {
      const matchingRecentSearches = _.take(recentSearchesPluginStore.getState().recentSearches, 4)
        .filter(
          recentSearch =>
            !searchText ||
            (recentSearch.searchScopes.every(scope => searchScopes.includes(scope)) &&
              recentSearch.searchText.toUpperCase().includes(searchText.toUpperCase())),
        )
        .map(state => ({
          id: state.id,
          Component: SearchResultsListItemRecentSearch,
          props: {
            id: state.id,
            searchText: state.searchText,
            searchScopes: state.searchScopes,
            type: RECENT_SEARCHES_SECTION_TITLE,
          },
        }));

      if (!matchingRecentSearches.length) return [];

      const results: ResultItem[] = [];

      results.push(
        ..._.take(recentSearchesPluginStore.getState().recentSearches, 4)
          .filter(recentSearch =>
            recentSearch.searchText.toUpperCase().includes(searchText.toUpperCase()),
          )
          .map(state => ({
            id: state.id,
            Component: SearchResultsListItemRecentSearch,
            type: RECENT_SEARCHES_SECTION_TITLE,
            props: {
              id: state.id,
              searchText: state.searchText,
              searchScopes: state.searchScopes,
            },
          })),
      );

      return results;
    },
    onLinkItemClick: state => {
      recentSearchesPluginStore.getState().onSaveRecentSearch(state);
    },
  };
};

export { recentSearchesPlugin };
